import { createActions, handleActions, Action } from "redux-actions";
import { ActionCreatorsOf } from "~libs/actionCreatorsOf";
import { GetVersionesResponse } from "~api/catalogos";
import { Services } from "~api/services";

interface Modelo {
  label: string;
  value: string;
}

interface FetchVehiculoModelosCompletedPayload {
  modelos: Modelo[];
}

interface VehiculoModelosState {
  isLoading: boolean;
  modelos: Modelo[];
}

const fetchVehiculoModelos = (marca: string, anio: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(fetchVehiculoModelosInited());

      const response = await services.api.vehiculos().getModelos(marca, anio);

      dispatch(fetchVehiculoModelosCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(fetchVehiculoModelosFailed(error));
    }
  };
};

const creators = {
  vehiculoModelosReducer: {
    clear: () => ({}),
    setMarca: (value: Modelo) => ({ value }),
    setModelo: (value: Modelo) => ({ value }),
    //
    fetchVehiculoModelosInited: () => ({}),
    fetchVehiculoModelosCompleted: (
      response: GetVersionesResponse | null | undefined
    ): FetchVehiculoModelosCompletedPayload => {
      let modelos: Modelo[] = [];

      if (response?.items != null) {
        modelos = response.items.map((x) => ({
          value: x.codia,
          label: x.version,
        }));
      }

      return { modelos };
    },
    fetchVehiculoModelosFailed: (error: unknown) => ({ error }),
  },
};

const {
  vehiculoModelosReducer: {
    clear,
    fetchVehiculoModelosInited,
    fetchVehiculoModelosCompleted,
    fetchVehiculoModelosFailed,
  },
} = createActions(creators) as unknown as ActionCreatorsOf<typeof creators>;

const initialState: VehiculoModelosState = { isLoading: false, modelos: [] };

export const vehiculoModelosReducer = handleActions<VehiculoModelosState, any>(
  {
    [clear.toString()]: (): VehiculoModelosState => {
      return { ...initialState };
    },
    [fetchVehiculoModelosInited.toString()]: (
      state: VehiculoModelosState
    ): VehiculoModelosState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [fetchVehiculoModelosCompleted.toString()]: (
      state: VehiculoModelosState,
      action: Action<FetchVehiculoModelosCompletedPayload>
    ): VehiculoModelosState => {
      return {
        ...state,
        modelos: [...action.payload.modelos],
        isLoading: false,
      };
    },
    [fetchVehiculoModelosFailed.toString()]: (
      state: VehiculoModelosState
    ): VehiculoModelosState => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
  initialState
);

export default vehiculoModelosReducer;
export { clear, fetchVehiculoModelos };
